import { Labeling } from '@grid/models';
import { StaticMessage } from '@shared/enums';
import { getStaticMessage } from '../localization';

export const GridDefaultLabels: Partial<Labeling> = {
  okButton: getStaticMessage(StaticMessage.OkButton),
  cancelButton: getStaticMessage(StaticMessage.CancelButton),
  deleteButton: getStaticMessage(StaticMessage.DeleteButton),
  copyButton: getStaticMessage(StaticMessage.CopyButton),
  noRowsMessage: getStaticMessage(StaticMessage.NoGridRecordsText),
  entityName: getStaticMessage(StaticMessage.DefaultEntityNameLabel),
  entityNamePlural: getStaticMessage(
    StaticMessage.DefaultEntityPluralNameLabel
  ),
  addButton: getStaticMessage(StaticMessage.DefaultEntityAddNameLabel),
  addShortcutTooltip: getStaticMessage(StaticMessage.AddShortcutTooltip),
  unassignedGroupLabel: getStaticMessage(StaticMessage.UnassignedLabel),
  importButton: getStaticMessage(StaticMessage.ImportButton),
};
